import type {UpdateExpedientFormPayload} from "./update-expedient.schema";
import {UpdateExpedientBody} from "@project/sdk/sales/zod";
import {updateExpedient} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientKeys, expedientMutationKeys} from "../../../expedient-keys";

export function updateExpedientMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: expedientMutationKeys.updateExpedient,
    mutationFn: (payload: UpdateExpedientFormPayload) =>
      updateExpedient(id, UpdateExpedientBody.parse(payload)),
    onSuccess: async (_result, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: expedientKeys.detail(id)}),
        client.invalidateQueries({queryKey: expedientKeys.lists()}),
      ]);
    },
  });
}
